import React, { useEffect, useState } from "react";
import { useI18next } from "../../../../plugins/gatsby-plugin-ap-i18next/src/useI18next";
import { RouteComponentProps } from "@reach/router";
import { navigate } from "gatsby";
import { useDispatch, useSelector } from "react-redux";

import {
    container,
    section,
    content,
    text,
    titleSvg,
    header,
    list,
    item,
    card,
    error,
    sharebuttons,
    shareallbutton,
    shareWrapper,
    stylizationHeader,
    postTitles,
    buttonsWrapper,
    returnButton,
    buttonContent,
    mobileStylization,
    mobileHeroCard,
    mobileHeroImageWrap,
    mobileHeroImage,
    mobileHeroZoom,
    mobileHeroZoomIcon,
    mobileHeroTryOn,
    mobileHeroTryOnReady,
    mobileHeroTryOnLoading,
    mobileHeroFavorite,
    mobileHeroFavoriteActive,
    mobileHeroBrand,
    mobileHeroButton,
    mobileThumbnails,
    mobileThumbnail,
    mobileThumbnailActive,
    mobileThumbnailImage,
    mobileThumbnailLabel,
    tryOnWorkspace,
    tryOnWorkspaceWithResult,
    tryOnProductsColumn,
    tryOnResultPanel,
    tryOnResultHeading,
    tryOnResultText,
    tryOnResultImage,
    tryOnResultNotice,
    tryOnResultEmpty,
} from "./stylization-view.module.scss";
import { mainGrid } from "../../../styles/grid.module.scss";
import Congratulation from "../../../assets/images/svg/success.svg";
import ShareIcon from "../../../assets/images/svg/share.svg";
import ImageIcon from "../../../assets/images/svg/imageDownload.svg";
import ViewIcon from "../../../assets/images/svg/view.svg";
import { IStylization } from "../../../models/stylization.model";
import { TStatus } from "../../../models/status.model";
import { getAbsolutePath } from "../../utility/routes.utility";
import getNodes from "../../../utils/get-nodes";
import getPostsWithAuthor from "../../../utils/get-posts-with-author";
import {
    selectSingleStylization,
    selectSingleStylizationStatus,
} from "../../../redux/single-stylization/single-stylization.selectors";
import {
    clearSingleStylizationAction,
    getSingleStylizationAction,
} from "../../../redux/single-stylization/single-stylization.actions";

import { useStaticQuery, graphql } from "gatsby";
import { useLocation } from "@reach/router";

import {
    FacebookShareButton,
    FacebookIcon,
    TwitterShareButton,
    TwitterIcon,
    LinkedinShareButton,
    LinkedinIcon,
} from "react-share";
import Section from "../../../components/molecules/section";
import Title from "../../../components/atoms/title";
import ProductCard from "../molecules/product-card";
import Button from "../../../components/atoms/button";
import Loader from "../../../components/atoms/loader";
import { Helmet } from "react-helmet";
import moment from "moment";
import WidgetBox from "../../../components/organisms/sections/common/widget-box";
import PostsSection from "../../../components/organisms/sections/posts-section";
import { IAuthor } from "../../../models/author.model";
import { IPostBrief } from "../../../models/post.model";
import { setAlert } from "../../../redux/alerts/alerts.actions";
import { USER } from "../../../redux/user/user.reducer";
import instance2 from "../../../api/axiosInstance2";
import endpoints from "../../../config/endpoints";
import useMediaQuery from "../../../hooks/use-media-query";
import { breakpoints } from "../../../config/breakpoints";
import useUser from "../../auth/hooks/use-user";
import favoriteIcon from "../../../assets/icons/favorite.svg";
import {
    getFavoriteProductIds,
    toggleFavoriteProduct,
} from "../../../services/product-favorites-services";

type TStylizationViewProps = {
    stylizationId?: number;
    guid: string;
    isCongratulationSite?: boolean;
    shareView?: boolean;
} & RouteComponentProps;

const customIconProps = {
    size: 40,
    bgStyle: {
        fill: "none",
    },
    iconFillColor: "black",
};

const StylizationView: React.FC<TStylizationViewProps> = ({
    stylizationId,
    guid,
    isCongratulationSite,
    shareView = false,
}) => {
    const { t } = useI18next();
    const dispatch = useDispatch();

    const { site, promotedPosts, authors } = useStaticQuery(query);

    const promotedPostsData = getNodes(promotedPosts);// as IPostBrief[];
    const authorsData = getNodes(authors);// as IAuthor[];
    const postsWithAuthor = getPostsWithAuthor(promotedPostsData, authorsData);
    const isTablet = useMediaQuery(breakpoints.tablet);

    const [shareUrl, setShareUrl] = useState('');


    const { pathname } = useLocation();


    const {
        url: siteUrl,
        shareApiUrl: shareApiUrl
    } = site.siteMetadata;

    const seo = {
        url: `${siteUrl}${pathname}`,
    };

    const stylization: IStylization | null = useSelector(selectSingleStylization);
    const status: TStatus = useSelector(selectSingleStylizationStatus);

    const { name, products = [], occasion } = stylization || {};

    const [tryOnLoadingProductId, setTryOnLoadingProductId] = useState<number | null>(null);
    const [tryOnReadyProductIds, setTryOnReadyProductIds] = useState<Set<number>>(new Set());
    const [tryOnResultUrl, setTryOnResultUrl] = useState<string | null>(null);
    const [tryOnActiveProductId, setTryOnActiveProductId] = useState<number | null>(null);
    const [tryOnMessage, setTryOnMessage] = useState<string | null>(null);
    const [activeMobileProductIndex, setActiveMobileProductIndex] = useState(0);
    const [favoriteProductIds, setFavoriteProductIds] = useState<Set<number>>(new Set());
    const [favoriteSavingId, setFavoriteSavingId] = useState<number | null>(null);
    const { isLoggedIn } = useUser();
    const productIdsKey = products.map(product => product.productId).join(",");



    const handleReturn = () => {
        navigate(getAbsolutePath("ACCOUNT_STYLIZATIONS"));
    };

    const shareAll = async () => {
        const shareData = {
            title: "Fashionfairy stylizacja",
            text: "Zobacz jaką stylizację mi wyczarowali!",
            url: shareUrl,
        };
        if (navigator.share) {
            try {
                await navigator.share(shareData);
            } catch (err) {
                console.error("Share failed:", err.message);
            }
        } else {
            // fallback – pokaż popup z linkiem
            navigator.clipboard.writeText(shareUrl);
            //alert(`Link został skopiowany do schowka: ${shareUrl}`);
            dispatch(setAlert({ type: "success", content: `Link został skopiowany do schowka.` }, { entity: USER }))
        }
    }

    useEffect(() => {
        console.log("stylizationId: ", stylizationId);
        console.log("stylization guid: ", guid);
        if (!stylizationId) return;
        dispatch(getSingleStylizationAction(stylizationId, guid));
        return () => {
            dispatch(clearSingleStylizationAction());
        };
    }, [dispatch, stylizationId, guid]);

    useEffect(() => {
        let share = shareApiUrl + "/stylization/view/" + stylizationId + "/" + stylization?.guid;
        console.log('share: ', share);
        setShareUrl(share);
    }, [JSON.stringify(stylization)]);

    useEffect(() => {
        setActiveMobileProductIndex(0);
    }, [products.length]);

    useEffect(() => {
        let isMounted = true;
        if (!isLoggedIn || products.length === 0) {
            setFavoriteProductIds(new Set());
            return () => {
                isMounted = false;
            };
        }

        getFavoriteProductIds()
            .then((ids) => {
                if (isMounted) {
                    setFavoriteProductIds(new Set(ids));
                }
            })
            .catch(() => {
                if (isMounted) {
                    setFavoriteProductIds(new Set());
                }
            });

        return () => {
            isMounted = false;
        };
    }, [isLoggedIn, productIdsKey]);

    useEffect(() => {
        return () => {
            if (tryOnResultUrl) {
                URL.revokeObjectURL(tryOnResultUrl);
            }
        };
    }, [tryOnResultUrl]);

    useEffect(() => {
        let isMounted = true;
        if (!isLoggedIn || !stylizationId) {
            setTryOnReadyProductIds(new Set());
            return () => { isMounted = false; };
        }
        instance2.get(endpoints.virtualTryOnProfile.list, {
            params: { stylizationId },
            withCredentials: true,
        }).then((response) => {
            if (isMounted) {
                setTryOnReadyProductIds(new Set((response.data?.productIds || []).map(Number)));
            }
        }).catch(() => {
            if (isMounted) setTryOnReadyProductIds(new Set());
        });
        return () => { isMounted = false; };
    }, [isLoggedIn, stylizationId]);

    const downloadImage = async (url, filename = "image.jpg") => {
        const response = await fetch(url, { mode: "cors" });
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
    };

    const replaceTryOnResult = (blob: Blob, productId: number) => {
        if (tryOnResultUrl) URL.revokeObjectURL(tryOnResultUrl);
        setTryOnResultUrl(URL.createObjectURL(blob));
        setTryOnActiveProductId(productId);
    };

    const showSavedTryOn = async (productId: number) => {
        if (!stylizationId) return;
        setTryOnLoadingProductId(productId);
        setTryOnMessage(null);
        try {
            const response = await instance2.get(endpoints.virtualTryOnProfile.result, {
                params: { stylizationId, productId },
                withCredentials: true,
                responseType: "blob",
                timeout: 310000,
            });
            replaceTryOnResult(response.data, productId);
        } catch {
            setTryOnMessage("Nie udało się otworzyć zapisanego ubioru. Spróbuj ponownie.");
        } finally {
            setTryOnLoadingProductId(null);
        }
    };

    const handleProfileTryOn = async (productId: number) => {
        if (!isLoggedIn) {
            navigate(getAbsolutePath("AUTH"));
            return;
        }
        if (!stylizationId || !productId || tryOnLoadingProductId) return;
        if (tryOnReadyProductIds.has(productId)) {
            await showSavedTryOn(productId);
            return;
        }
        setTryOnLoadingProductId(productId);
        setTryOnMessage(null);
        try {
            const response = await instance2.post(
                endpoints.virtualTryOnProfile.create,
                { stylizationId, productId },
                { withCredentials: true, responseType: "blob", timeout: 310000 }
            );
            replaceTryOnResult(response.data, productId);
            setTryOnReadyProductIds((current) => new Set(current).add(productId));
        } catch {
            setTryOnMessage("Nie udało się wykonać przymiarki. Sprawdź zdjęcie profilowe i spróbuj ponownie.");
        } finally {
            setTryOnLoadingProductId(null);
        }
    };

    const handleFavoriteClick = async (
        event: React.MouseEvent<HTMLButtonElement>,
        productId: number
    ) => {
        event.preventDefault();
        event.stopPropagation();

        if (!isLoggedIn || !productId || favoriteSavingId) {
            return;
        }

        const previousIds = new Set(favoriteProductIds);
        const nextIds = new Set(favoriteProductIds);
        if (nextIds.has(productId)) {
            nextIds.delete(productId);
        } else {
            nextIds.add(productId);
        }

        setFavoriteProductIds(nextIds);
        setFavoriteSavingId(productId);

        try {
            const isFavorite = await toggleFavoriteProduct(productId);
            setFavoriteProductIds((currentIds) => {
                const syncedIds = new Set(currentIds);
                if (isFavorite) {
                    syncedIds.add(productId);
                } else {
                    syncedIds.delete(productId);
                }
                return syncedIds;
            });
        } catch {
            setFavoriteProductIds(previousIds);
        } finally {
            setFavoriteSavingId(null);
        }
    };

    return (
        <>

            {shareView && <WidgetBox alwaysVisible={true} />}
            <div className={`${container} ${mainGrid}`}>
                <Section className={section}>
                    <div className={content}>
                        {(!status || status === "loading" || status === "idle") && (
                            <Loader position={"absolute"} />
                        )}
                        {status === "fail" && (
                            <p className={error}>{t("generator.stylization.fail")}</p>
                        )}
                        {status === "success" && stylization && (
                            <>

                                {isCongratulationSite ? (
                                    <div className={header}>
                                        <Congratulation className={titleSvg} />
                                        <h1 className={text}>{t("generator.stylization.ready")}</h1>
                                    </div>
                                ) : (
                                    <div className={stylizationHeader}>
                                        {occasion?.label}
                                    </div>
                                    // <Title
                                    //     Tag="h1"
                                    //     subtitle={""}
                                    //     align="center"
                                    //     fontStyle="italic"
                                    // >
                                    //     {occasion?.label}
                                    // </Title>
                                )}
                                <Helmet>
                                    <meta name="image" content={stylization.shareUrl} />
                                    <meta property="og:image" content={stylization.shareUrl} />
                                    <meta property="twitter:image" content={stylization.shareUrl} />
                                    <meta property="og:url" content={shareUrl} />
                                </Helmet>
                                {!shareView &&
                                    <div className={buttonsWrapper}>
                                        <Button onClick={handleReturn} type="filled" className={returnButton}>
                                            {isCongratulationSite
                                                ? t(`generator.stylization.ready.button`)
                                                : t(`generator.stylization.view.button`)}
                                        </Button>
                                    </div>}
                                <div className={`${tryOnWorkspace} ${tryOnResultUrl ? tryOnWorkspaceWithResult : ""}`}>
                                    <div className={tryOnProductsColumn}>
                                        {isTablet && products.length > 0 && (() => {
                                    const activeProduct = products[
                                        Math.min(activeMobileProductIndex, products.length - 1)
                                    ];

                                    return (
                                        <div className={mobileStylization}>
                                            <div className={mobileHeroCard}>
                                                <div className={mobileHeroImageWrap}>
                                                    <img
                                                        src={activeProduct.imgUrl}
                                                        alt={activeProduct.category || "Produkt"}
                                                        className={mobileHeroImage}
                                                    />
                                                    <a
                                                        href={activeProduct.affiliateUrl || activeProduct.url}
                                                        className={mobileHeroZoom}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        aria-label="Przejdź do produktu"
                                                    >
                                                        <ViewIcon className={mobileHeroZoomIcon} aria-hidden />
                                                    </a>
                                                    {isLoggedIn && activeProduct.productId && (
                                                        <button
                                                            type="button"
                                                            className={`${mobileHeroTryOn} ${
                                                                tryOnReadyProductIds.has(Number(activeProduct.productId)) ? mobileHeroTryOnReady : ""
                                                            } ${tryOnLoadingProductId === Number(activeProduct.productId) ? mobileHeroTryOnLoading : ""}`}
                                                            onClick={() => handleProfileTryOn(Number(activeProduct.productId))}
                                                            disabled={!!tryOnLoadingProductId}
                                                            aria-label={tryOnReadyProductIds.has(Number(activeProduct.productId)) ? "Pokaż gotowy ubiór" : "Załóż ubranie"}
                                                        >
                                                            {tryOnReadyProductIds.has(Number(activeProduct.productId)) ? "✓" : "👚"}
                                                        </button>
                                                    )}
                                                    {isLoggedIn && activeProduct.productId && (
                                                        <button
                                                            type="button"
                                                            className={`${mobileHeroFavorite} ${
                                                                favoriteProductIds.has(Number(activeProduct.productId))
                                                                    ? mobileHeroFavoriteActive
                                                                    : ""
                                                            }`}
                                                            disabled={favoriteSavingId === Number(activeProduct.productId)}
                                                            onClick={(event) =>
                                                                handleFavoriteClick(event, Number(activeProduct.productId))
                                                            }
                                                            aria-pressed={favoriteProductIds.has(Number(activeProduct.productId))}
                                                            aria-label={
                                                                favoriteProductIds.has(Number(activeProduct.productId))
                                                                    ? "Usuń produkt z ulubionych"
                                                                    : "Dodaj produkt do ulubionych"
                                                            }
                                                        >
                                                            <img src={favoriteIcon} alt="" aria-hidden="true" />
                                                        </button>
                                                    )}
                                                </div>
                                                {activeProduct.brandName && (
                                                    <div className={mobileHeroBrand}>
                                                        {activeProduct.brandName}
                                                    </div>
                                                )}
                                                <a
                                                    href={activeProduct.affiliateUrl || activeProduct.url}
                                                    className={mobileHeroButton}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Sprawdź dostępność
                                                </a>
                                            </div>
                                            <div className={mobileThumbnails}>
                                                {products.map((product, index) => (
                                                    <button
                                                        key={product.productId}
                                                        type="button"
                                                        className={`${mobileThumbnail} ${
                                                            index === activeMobileProductIndex
                                                                ? mobileThumbnailActive
                                                                : ""
                                                        }`}
                                                        onClick={() => setActiveMobileProductIndex(index)}
                                                        aria-label={`Pokaż element stylizacji ${index + 1}`}
                                                    >
                                                        <img
                                                            src={product.imgUrl}
                                                            alt={product.category || "Produkt"}
                                                            className={mobileThumbnailImage}
                                                        />
                                                        <span className={mobileThumbnailLabel}>
                                                            {product.typeClothes ||
                                                                product.category ||
                                                                product.brandName ||
                                                                "Produkt"}
                                                        </span>
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })()}
                                {!isTablet && <ul className={list}>
                                    {products.map((product) => {
                                        return (
                                            <li key={product.productId} className={item}>
                                                <ProductCard
                                                    isTablet={false}
                                                    product={product}
                                                    className={card}
                                                    classNameButtonContent={buttonContent}
                                                    productLength={products.length}
                                                    tryOnEnabled={isLoggedIn}
                                                    tryOnState={
                                                        tryOnLoadingProductId === Number(product.productId)
                                                            ? "loading"
                                                            : tryOnReadyProductIds.has(Number(product.productId))
                                                                ? "ready"
                                                                : "idle"
                                                    }
                                                    onTryOn={handleProfileTryOn}
                                                    onLoginRequired={() => navigate(getAbsolutePath("AUTH"))}
                                                />

                                            </li>
                                        );
                                    })}
                                </ul>}
                                    </div>
                                    {(tryOnResultUrl || tryOnLoadingProductId || tryOnMessage) && (
                                        <aside className={tryOnResultPanel} aria-live="polite">
                                            <h2 className={tryOnResultHeading}>Twój ubiór</h2>
                                            <p className={tryOnResultText}>
                                                {tryOnLoadingProductId
                                                    ? "Tworzymy ubiór na Twoim zdjęciu..."
                                                    : "Kliknij ikonę ubrania przy produkcie, aby zmienić element."}
                                            </p>
                                            {tryOnResultUrl ? (
                                                <img className={tryOnResultImage} src={tryOnResultUrl} alt="Zapisany wynik wirtualnej przymiarki" />
                                            ) : !tryOnLoadingProductId && (
                                                <p className={tryOnResultEmpty}>Wybierz produkt, aby zobaczyć ubiór.</p>
                                            )}
                                            {tryOnMessage && <p className={tryOnResultNotice}>{tryOnMessage}</p>}
                                        </aside>
                                    )}
                                </div>
                                {!shareView && <div className={shareWrapper}>
                                    <p>Podziel się ze znajomymi:</p>
                                    <div className={sharebuttons}>
                                        <FacebookShareButton url={shareUrl}>
                                            <FacebookIcon {...customIconProps}></FacebookIcon>
                                        </FacebookShareButton>
                                        <TwitterShareButton url={shareUrl}>
                                            <TwitterIcon {...customIconProps} />
                                        </TwitterShareButton>
                                        <LinkedinShareButton url={shareUrl}>
                                            <LinkedinIcon {...customIconProps} />
                                        </LinkedinShareButton>
                                        <div className={shareallbutton}>
                                            <ImageIcon onClick={() => downloadImage(stylization.shareUrl, "stylizacja.jpg")}></ImageIcon>
                                        </div>
                                        <div className={shareallbutton}>
                                            <ShareIcon onClick={shareAll}></ShareIcon>
                                        </div>
                                    </div>
                                </div>}
                            </>
                        )}
                    </div>
                    {shareView}
                </Section>
            </div>
            {shareView && postsWithAuthor.length > 0 && (
                <>
                    <div className={postTitles}>
                        <h2>✨ Najnowsze artykuły</h2>
                    </div>
                    <PostsSection
                        posts={postsWithAuthor}
                        authors={authorsData}
                        titleKey="posts-section.title"
                        subtitleKey="common.blog"
                        showNew={true}
                    />
                </>
            )}
        </>
    );
};

const query = graphql`
    query {
        site {
            siteMetadata {
                title
                description
                image
                url
                shareApiUrl
            }
        }
        promotedPosts: allPost(sort: { fields: publishedAt, order: DESC }, limit: 4) {
            edges {
                node {
                    ...postBriefFields
                }
            }
        }

        authors: allAuthor {
            edges {
                node {
                    ...authorFields
                }
            }
        }
    }
`;
export default StylizationView;
